'use client';
import { useEffect } from 'react';
import mixpanel, { type OverridedMixpanel } from 'mixpanel-browser';
import { getCookie } from '@/utils/cookie';
import userStore from '@/stores/userStore';

//初始化 Mixpanel
export interface MixpanelProps {
  mixpanelId: string;
  onInit?: (instance: OverridedMixpanel) => void;
}
export function Mixpanel(props: MixpanelProps) {
  const { mixpanelId, onInit } = props;

  const { displayName, user } = userStore();

  useEffect(() => {
    try {
      if (typeof window === 'undefined') {
        return;
      }
      // 从 cookie 中获取 UTM 数据
      const utmData = getCookie('init_query');

      // 初始化 mixpanel
      mixpanel.init(mixpanelId, {
        autocapture: true,
      });

      // 如果 cookie 中有值，设置为超级属性
      const superProperties: Record<string, string> = {};

      if (utmData) {
        // 解析 cookie 中的 UTM 参数
        const params = new URLSearchParams(utmData);
        params.forEach((value, key) => {
          superProperties[key] = value;
        });
      }

      // 如果有超级属性，注册到 mixpanel
      if (Object.keys(superProperties).length > 0) {
        mixpanel.register(superProperties);
      }

      const env = process.env.env || 'dev';
      mixpanel.register({ env });

      // 初始化完成后调用回调，传递 mixpanel 实例
      if (onInit) {
        onInit(mixpanel);
      }
    } catch (error) {
      console.error('Init Mixpanel Error:', error);
    }
  }, [onInit, mixpanelId]);

  useEffect(() => {
    console.log('Mixpanel User Update:', user);
    if (user) {
      console.log('Identify Mixpanel User Add', user, displayName);
      mixpanel.identify(user.userId);
      mixpanel.register({
        user_name: displayName,
        email: user.email || '',
        distinctId: user.userId,
      });
    } else {
      console.log('Identify Mixpanel User register reset');
      mixpanel.register({
        user_name: '',
        email: '',
        distinctId: '',
      });
    }
  }, [user, user?.userId, user?.email, displayName]);

  return null;
}
